import * as React from 'react';

const GoogleAnalyticsBarsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={36}>
    <g>
      <path fill="#fff" d="M0 .222h32v35.556H0z" />
      <path
        fill="#F9AB00"
        fillRule="evenodd"
        d="M31.998 31.328a4.41 4.41 0 0 1-4.921 4.412 4.527 4.527 0 0 1-3.853-4.593V4.845a4.529 4.529 0 0 1 3.86-4.592 4.406 4.406 0 0 1 4.914 4.41v26.665Z"
        clipRule="evenodd"
      />
      <path
        fill="#E37400"
        fillRule="evenodd"
        d="M4.388 26.97a4.396 4.396 0 0 1 4.388 4.404 4.396 4.396 0 0 1-4.388 4.404A4.396 4.396 0 0 1 0 31.374a4.396 4.396 0 0 1 4.388-4.404Zm11.544-13.347a4.525 4.525 0 0 0-4.267 4.63v11.829c0 3.21 1.408 5.159 3.47 5.574a4.395 4.395 0 0 0 5.268-4.335V18.049c.004-2.441-1.963-4.423-4.395-4.428-.025 0-.051 0-.076.002Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export default GoogleAnalyticsBarsIcon;
